import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    pr_code: {
      name: 'เลขที่รายการ',
      width: '8rem',
      // eslint-disable-next-line
      filter: (val: any) => val ? val.pr_code : 'ไม่ระบุ',
    },
    // type: {
    //   name: 'ประเภท',
    //   width: '6rem',
    //   filter: (val: string, row: { item: { [key: string]: any }; index: number }) => typeTranslate(val),
    //   class: {
    //     text(val: string, row: { item: { [key: string]: any }; index: number }) {
    //       return classMap(val);
    //     },
    //   },
    // },
    material: {
      name: 'รหัสชิ้นส่วน',
      width: '1fr',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => {
        if (row.item.bom_item?.production_type === 'FAB') return row.item.bom_item?.drawing_no;
        return row.item.material?.code;
      },
    },
    name: {
      name: 'ชื่อชิ้นส่วน',
      width: '1.5fr',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => row.item.material?.name,
    },
    brand: {
      name: 'Brand',
      width: '1fr',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => row.item.material?.brand,
    },
    amount: {
      name: 'จำนวน',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    created_at: {
      name: 'หน่วย',
      width: '6rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => row.item.material?.unit,
    },
    'bom_item.target_date': {
      name: 'กำหนดส่ง',
      width: '12rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayFullThaiDate() : 'ไม่ระบุ',
    },
  },
};
